import { getNumberFormatter } from './numberFormatter';

export const formatNumberWithCommas = (
  value: number | string,
  decimals = 2,
  minimumFractionDigits: number | undefined = undefined,
): string => {
  const numValue = Number(value);

  if (Number.isNaN(numValue) || !Number.isFinite(numValue)) {
    return '0';
  }

  const formatted = getNumberFormatter(minimumFractionDigits ?? decimals, decimals).format(numValue || 0);

  return formatted;
};
